module.exports = __webpack_public_path__ + "img/number_1.92374c95.png";